import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/google/session`, { session_id: sessionId })
      .then(({ data }) => {
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data);
        navigate(data.role === "therapist" ? "/therapist" : "/dashboard", {
          replace: true,
          state: { user: data },
        });
      })
      .catch(() => navigate("/login", { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-zinc-950"
      data-testid="auth-callback-loading"
    >
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-zinc-400">Anmeldung wird abgeschlossen…</p>
      </div>
    </div>
  );
}
